import manager from '../Manager';
import VideoPreviewBunnynet from './VideoPreview/bunnynet'
import { IconPreviewAmazon, IconPlayStore, IconAppStore } from '../icons/svgs';
import Utils from '../CourseApp/Helper/utils';

function NoData() {
    return (
        <div className="tbcourse-template-audios-item">
            <span>
                <img src={require('../assets/img/audio-frame.jpg')} className='img-fluid' alt='no data' />
            </span>
        </div>
    );
}

function appStoreNotReady() {
    return Utils.showInfo('Brainboost App is coming soon on Appstore');
}

function AudioPreview({ data, index, structures }) {
    let audio = (data.audio) ? data.audio : false;
    const platform = data.platform;
    const hasKey = (key, obj) => key in obj;

    return (
        <div className="tbcourse-template tbcourse-template-audio" key={index}>
            <div>
                <div className="tbcourse-template-text-title">
                    {data?.title ? data.title : structures.title?.placeholder}
                </div>
                <div className="tbcourse-template-text-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description?.placeholder : '' }}></div>
                    {typeof data.platform === 'undefined' || platform === 'bunnynet' || (platform === 'amazon' && (audio === false || !hasKey('s3', audio))) ? (
                        <div className="tbcourse-template-audios">
                            {!audio.directPlayUrl || audio.directPlayUrl === "" ? (<NoData />) : (<VideoPreviewBunnynet videoData={audio} type={'audio'} customHeight={"142px"} />)}
                        </div>
                    ) : (
                        <div className="tbcourse-template-audios">
                            <div className='tbcourse-template-audios-amazon'>
                                <IconPreviewAmazon />
                                <div className='tbcourse-template-audios-amazon-title margin-top-button'>Kamu Bisa Akses konten</div>
                                <div className='tbcourse-template-audios-amazon-title'>Audio di BrainBoost</div>
                                <div className='tbcourse-template-audios-amazon-desc margin-top-button'>Untuk pengalaman yang lebih baik, silakan</div>
                                <div className='tbcourse-template-audios-amazon-desc'>download aplikasi <span className='tbcourse-template-audios-amazon-desc-bold'>BrainBoost</span> dan akses</div>
                                <div className='tbcourse-template-audios-amazon-desc'>kontenmu langsung dari sana.</div>
                                <a href='https://play.google.com/store/apps/details?id=com.brainboost.android' target="_blank" className='tbcourse-template-audios-amazon-button margin-top-button' rel="noreferrer">
                                    <IconPlayStore />
                                    <span className='tbcourse-template-audios-amazon-button-ms'>Download di Playstore</span>
                                </a>
                                <a href='javascript:;' className='tbcourse-template-audios-amazon-button margin-top-button' onClick={appStoreNotReady} rel="noreferrer">
                                    <IconAppStore />
                                    <span className='tbcourse-template-audios-amazon-button-ms'>Download di Appstore</span>
                                </a>
                            </div>
                        </div>
                    )}
            </div>
        </div>
    )
}

export default AudioPreview;
